import { useEffect, useRef } from 'react'

export type CaptionSize = 'small' | 'medium' | 'large'

export interface CaptionEntry {
  id: string
  from: string
  text: string
  final: boolean
  ts: number // Date.now() when received
}

interface CaptionOverlayProps {
  captions: CaptionEntry[]
  size: CaptionSize
}

const SIZE_CLASSES: Record<CaptionSize, string> = {
  small: 'text-xs',
  medium: 'text-sm',
  large: 'text-base',
}

const AUTO_HIDE_MS = 5000

export function CaptionOverlay({ captions, size }: CaptionOverlayProps) {
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [captions])

  // Only show captions from last AUTO_HIDE_MS
  const now = Date.now()
  const visible = captions.filter(c => now - c.ts < AUTO_HIDE_MS).slice(-3)

  if (visible.length === 0) return null

  return (
    <div className="absolute bottom-14 left-1/2 -translate-x-1/2 w-[80%] max-w-2xl pointer-events-none z-30">
      <div className="bg-black/70 rounded-lg px-4 py-2 space-y-0.5">
        {visible.map(c => (
          <div key={c.id} className={`${SIZE_CLASSES[size]} leading-snug`}>
            <span className="text-cyan-400 font-medium">[{c.from}]</span>{' '}
            <span className={c.final ? 'text-white' : 'text-zinc-400 italic'}>{c.text}</span>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
    </div>
  )
}
